export default __webpack_public_path__ + "static/media/Snd_Try2.e99bb9ab.mp3";